import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=80e96f6e&scoped=true"
import script from "./SearchCustomer.vue?vue&type=script&lang=ts"
export * from "./SearchCustomer.vue?vue&type=script&lang=ts"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=80e96f6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e96f6e",
  null
  
)

export default component.exports